export default __webpack_public_path__ + "static/media/create-member-img.9570f14c.png";